// Market wide configs
import analytics from "./shared/fr.analytics";
import nav_primary_config from "./shared/fr.nav.primary";

// education_primary
import education_primary_nav_secondary_config from "./sites/education-primary/fr-education-primary.nav.secondary";
import education_primary_pages_config from "./sites/education-primary/fr-education-primary.pages";
import education_primary_footer_config from "./sites/education-primary/fr-education-primary.footer";

// education_secondary
import education_secondary_nav_secondary_config from "./sites/education-secondary/fr-education-secondary.nav.secondary";
import education_secondary_pages_config from "./sites/education-secondary/fr-education-secondary.pages";
import education_secondary_footer_config from "./sites/education-secondary/fr-education-secondary.footer.js";

// enterprise
import enterprise_nav_secondary_config from "./sites/enterprise/fr-enterprise.nav.secondary.js";
import enterprise_pages_config from "./sites/enterprise/fr-enterprise.pages";
import enterprise_footer_config from "./sites/enterprise/fr-enterprise.footer";

export default ({ market, site, page, locale, strings }) => {
    let nav_secondary = null;
    let page_config = null;
    let footer_config = null;
    switch (site) {
        case "business":
        case "enterprise":
            nav_secondary = enterprise_nav_secondary_config({ strings });
            page_config = enterprise_pages_config({ page, strings });
            footer_config = enterprise_footer_config({ strings });
            break;
        case "k12":
        case "education-primary":
            nav_secondary = education_primary_nav_secondary_config({ strings });
            page_config = education_primary_pages_config({ page, strings });
            footer_config = education_primary_footer_config({ strings });
            break;
        case "hed":
        case "education-secondary":
            nav_secondary = education_secondary_nav_secondary_config({ strings });
            page_config = education_secondary_pages_config({ page, strings });
            footer_config = education_secondary_footer_config({ strings });
            break;
    }
    const nav_primary = nav_primary_config({ strings });

    return {
        market,
        site,
        locale,
        analytics,
        nav: {
            visible: true,
            primary: nav_primary || null,
            secondary: nav_secondary || null
        },
        footer: {
            visible: true,
            ...footer_config
        },

        page: page_config
    };
};
